jQuery(document).ready(function($) {
  //Sticky header   
  $(window).scroll(function () {
    if ($(this).scrollTop() > 170) {
      $("#masthead").addClass("sticky");
      $("body").addClass("sticky-header-open");
      // $('.go-top').addClass("go-top_sticky");
    } else {
      $("#masthead").removeClass("sticky");
      $("body").removeClass("sticky-header-open");
      // $('.go-top').removeClass("go-top_sticky");
    }
  });
});